/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataLoaderLoadingStatus {
    FAILED = 'failed',
    PARTIAL = 'partial',
    SUCCESSFUL = 'successful',
    CANCELED = 'canceled',
}
